import init_questions from "./items/questions";
import init_owner_tools from "./items/owner-tools";
import init_current_viewers from "./items/current-viewers";
import init_gallery_photoswipe from "./items/gallery-photoswipe";

jQuery(() => {
    init_questions();
    init_owner_tools();
    init_current_viewers();
    init_gallery_photoswipe();
});
